import { css } from 'lit';

export default css`
    .footer {
        padding: var(--metrics-spacing-xs) var(--metrics-spacing-s);
        border-top: solid 1px var(--color-border-divider-light);
        background-color: var(--color-surface-primary);
        text-align: right;
    }

    .footer__timezone {
        color: var(--color-text-secondary);
        font-size: var(--font-size-body-s);
    }
`;
